<template>

<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <path class="cls-1" d="m47.83,24.32l-.03,4.87c1.92.19,3.72.57,5.42,1.14,1.69.57,3.14,1.29,4.35,2.16l-2.3,6.32c-1.29-.92-2.82-1.66-4.59-2.2-1.77-.55-3.57-.83-5.4-.84-1.83-.01-3.12.23-3.86.73-.74.5-1.12,1.12-1.12,1.85,0,.62.24,1.15.74,1.58.5.43,1.41.8,2.74,1.1l5,1.1c5.42,1.25,8.12,4.21,8.09,8.87-.02,2.48-.87,4.58-2.55,6.29-1.68,1.71-3.93,2.83-6.74,3.34l-.04,5.09-6.16-.04.04-4.96c-1.53-.19-3-.57-4.4-1.14-1.4-.57-2.55-1.28-3.46-2.11l2.21-5.92c1.06.83,2.31,1.48,3.75,1.95,1.45.47,2.99.71,4.64.72,1.54.01,2.73-.26,3.6-.82.86-.56,1.29-1.27,1.3-2.16,0-.59-.24-1.09-.74-1.49-.5-.4-1.38-.76-2.65-1.06l-5-1.15c-5.51-1.25-8.25-4.15-8.22-8.69.02-2.51.87-4.6,2.57-6.27,1.7-1.67,3.9-2.75,6.62-3.23l.04-5.09,6.16.04Z"/>
  <g>
    <g>
      <g>
        <path class="cls-2" d="m32.17,26c-.24,0-.48-.09-.66-.28l-7.63-7.63c-.37-.37-.37-.96,0-1.33s.96-.37,1.33,0l7.63,7.63c.37.37.37.96,0,1.33-.18.18-.42.28-.66.28Z"/>
        <path class="cls-2" d="m28.1,14.26l-7.71-2.06c-.66-.18-1.27.43-1.09,1.09l2.06,7.71c.18.66,1,.88,1.49.4l5.64-5.64c.48-.48.26-1.31-.4-1.49Z"/>
      </g>
      <g>
        <path class="cls-2" d="m57.83,26c.24,0,.48-.09.66-.28l7.63-7.63c.37-.37.37-.96,0-1.33s-.96-.37-1.33,0l-7.63,7.63c-.37.37-.37.96,0,1.33.18.18.42.28.66.28Z"/>
        <path class="cls-2" d="m61.9,14.26l7.71-2.06c.66-.18,1.27.43,1.09,1.09l-2.06,7.71c-.18.66-1,.88-1.49.4l-5.64-5.64c-.48-.48-.26-1.31.4-1.49Z"/>
      </g>
    </g>
    <g>
      <g>
        <path class="cls-2" d="m57.83,64c.24,0,.48.09.66.28l7.63,7.63c.37.37.37.96,0,1.33s-.96.37-1.33,0l-7.63-7.63c-.37-.37-.37-.96,0-1.33.18-.18.42-.28.66-.28Z"/>
        <path class="cls-2" d="m61.9,75.74l7.71,2.06c.66.18,1.27-.43,1.09-1.09l-2.06-7.71c-.18-.66-1-.88-1.49-.4l-5.64,5.64c-.48.48-.26,1.31.4,1.49Z"/>
      </g>
      <g>
        <path class="cls-2" d="m32.17,64c-.24,0-.48.09-.66.28l-7.63,7.63c-.37.37-.37.96,0,1.33s.96.37,1.33,0l7.63-7.63c.37-.37.37-.96,0-1.33-.18-.18-.42-.28-.66-.28Z"/>
        <path class="cls-2" d="m28.1,75.74l-7.71,2.06c-.66.18-1.27-.43-1.09-1.09l2.06-7.71c.18-.66,1-.88,1.49-.4l5.64,5.64c.48.48.26,1.31-.4,1.49Z"/>
      </g>
    </g>
    <g>
      <g>
        <path class="cls-2" d="m64.65,45.39c.17-.17.4-.28.66-.29l10.8-.17c.52,0,.95.41.95.93s-.41.95-.93.95l-10.8.17c-.52,0-.95-.41-.95-.93,0-.26.1-.5.26-.67Z"/>
        <path class="cls-2" d="m75.91,50.64l6.85-4.1c.59-.35.57-1.21-.02-1.54l-6.97-3.88c-.6-.33-1.33.11-1.32.79l.12,7.98c.01.68.76,1.1,1.35.75Z"/>
      </g>
      <g>
        <path class="cls-2" d="m25.35,45.39c-.17-.17-.4-.28-.66-.29l-10.8-.17c-.52,0-.95.41-.95.93s.41.95.93.95l10.8.17c.52,0,.95-.41.95-.93,0-.26-.1-.5-.26-.67Z"/>
        <path class="cls-2" d="m14.09,50.64l-6.85-4.1c-.59-.35-.57-1.21.02-1.54l6.97-3.88c.6-.33,1.33.11,1.32.79l-.12,7.98c-.01.68-.76,1.1-1.35.75Z"/>
      </g>
    </g>
  </g>
</svg>
</template>

<script>
export default {
    name: "PriceDistributionIcon",
}
</script>

<style scoped>
  .cls-1 {
    fill: #115c72;
  }
  .cls-2 {
    fill: #59c5c7;
  }
</style>